import toast from 'react-hot-toast'

import type { FullShipment } from '@fv/client-types'
import { fvDateUtc } from '@fv/dates'

import { useSendSpotQuoteRequests } from '@/hooks/spotQuotes'

import type { SpotQuoteFormData } from './types'

type SubmitFormArgs = {
  load: FullShipment
}

export function useSubmitForm({ load }: SubmitFormArgs) {
  const { equipment, loadId } = load
  const loads = [load]
  const formData: SpotQuoteFormData[] = loads.map(l => ({
    loadId: l.loadId,
    ...(l.bidExpiration && {
      bidExpiration: {
        ...l.bidExpiration,
        utc: fvDateUtc(l.bidExpiration?.utc).toDate(),
      },
    }),
    targetPrice: l.targetPrice,
  }))
  const sendRequests = useSendSpotQuoteRequests(equipment.mode)

  return {
    isSending: sendRequests.isPending,
    isSent: sendRequests.isSuccess,
    onSubmit: (emails: string[]) => {
      if (emails.length < 1) {
        toast.error('Must select at least one contact to send out for quotes.')
        return
      }

      return sendRequests.mutateAsync({
        emails,
        targetPrices: formData,
        bidExpirations: formData,
        loadIds: [loadId],
      })
    },
  }
}
